import { List } from 'immutable';
import SkillSuggestion from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'selectedRecommendationList':
      return [key, new List(val.map((id) => `${id}`))];
    default:
      return [key, val];
  }
};

const create = (data) => new SkillSuggestion(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/Suggestions/SkillSuggestion/create.js